import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup, { RadioGroupProps } from "@material-ui/core/RadioGroup";
import { makeStyles } from "@material-ui/core/styles";
import { createStyles, Theme } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import WaitingForCustomerOptions, { waitingForCustomerOptionsDictionary } from "./WaitingForCustomerOptions";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexDirection: "row",
      flexWrap: "nowrap",
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down("lg")]: {
        marginRight: theme.spacing(-1.6),
      },
      [theme.breakpoints.up("lg")]: {
        marginRight: theme.spacing(2),
      },
    },
    noWrap: {
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
  }),
);

export interface WaitingForCustomerFilterProps extends RadioGroupProps {}

function WaitingForCustomerFilter(props: WaitingForCustomerFilterProps) {
  const classes = useStyles();
  return (
    <RadioGroup {...props} className={clsx([classes.root, props.className])}>
      {WaitingForCustomerOptions.map((option) => (
        <FormControlLabel
          key={option}
          className={classes.noWrap}
          control={<Radio />}
          label={waitingForCustomerOptionsDictionary[option]}
          value={option}
        />
      ))}
    </RadioGroup>
  );
}

export default WaitingForCustomerFilter;
